// Order grouped EventResults entries to match the form field order.
// `fields` is the EventFields list (already sorted by Position asc); its index is the order.
// `groups` is [{ fieldId, results }]. Fields missing from the list keep their relative order, last.
const orderResultsByFieldOrder = (groups, fields) => {
    if (!Array.isArray(groups)) return []

    const order = new Map()
    ;(Array.isArray(fields) ? fields : []).forEach((field, index) => {
        order.set(field.ID, index)
    })

    const LAST = Number.MAX_SAFE_INTEGER
    const rank = (group) => (order.has(group.fieldId) ? order.get(group.fieldId) : LAST)

    // copy first so we never mutate the caller's array (Array.sort is in-place + stable)
    return [...groups].sort((a, b) => rank(a) - rank(b))
}

export default orderResultsByFieldOrder
